import React from 'react';
import { motion } from 'framer-motion';
export function StoryBridge() {
  return <section className="bg-brand-lightAmber/50 py-12 px-6 border-y border-brand-amber/10" data-id="element-119">
      <div className="max-w-3xl mx-auto text-center" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-121">
          <h2 className="text-2xl font-bold text-brand-brown mb-4 font-sans" data-id="element-122">
            Das Produkt, das alles verändert hat
          </h2>
          <p className="text-lg text-stone-700 font-serif max-w-2xl mx-auto leading-relaxed" data-id="element-123">
            Das Magen-Darm-Topping von Hunderunde ist{' '}
            <strong data-id="element-124">100% pflanzlich</strong> und wurde speziell für Hunde mit
            empfindlichem Magen entwickelt. Was mich überzeugt hat: keine
            künstlichen Zusätze, nur natürliche Inhaltsstoffe – und hunderte
            positive Erfahrungen anderer Hundebesitzer.
          </p>
        </motion.div>
      </div>
    </section>;
}